import { useQuery } from "@tanstack/react-query";
import { WalletService } from "@/services/wallet.service";
import type { ForecastResponse } from '@/services/wallet.service';
import { useTranslation } from 'react-i18next';

export const useFetchForecasts = ({
  currentPage,
  start_date,
  end_date,
  currency,
}: {
  currentPage?: number;
  start_date?: string;
  end_date?: string;
  currency: string;
}) => {
  const { t } = useTranslation('common');

  const {
    data: forecasts,
    isPending: isLoading,
    refetch,
    isRefetching,
    error,
  } = useQuery<ForecastResponse>({
    queryKey: ['forecasts', currentPage, start_date, end_date, currency],
    queryFn: async () =>
      await WalletService.getForecasts({
        currentPage,
        start_date,
        end_date,
        currency,
      }),
  });

  return {
    forecasts,
    isLoading,
    refetch,
    isRefetching,
    error: error ? (error as Error).message || t('data_listing_error') : null,
  };
};